module.exports = __webpack_public_path__ + "img/blue-triangle-left.34c1dc8.png";